import { FC } from 'react';

import styled from 'styled-components';

const Dot = styled.div(({ theme }) => {
  return `
    height: 25px;
    width: 25px;
    border-radius: 1000px;
    background: red;
    position: absolute;
    z-index: 1;
    top: -10px;
    left: -8px;
    color: white;
    font-size: ${theme.type.size.tiny};
    text-align: center;
  `;
});

const Text = styled.div`
  position: relative;
  margin: 0 auto;
  text-align: center;
  top: 4px;
`;

export interface INotificationDot {
  on: boolean;
  count?: number;
}

const NotificationDot: FC<INotificationDot> = ({ on, count }) => {
  let countString = '';

  if (count) {
    countString = count > 99 ? `99+` : count.toString();
  }

  if (on) {
    return (
      <Dot>
        <Text>{countString}</Text>
      </Dot>
    );
  } else {
    return null;
  }
};

export default NotificationDot;
